// eslint-disable-next-line max-len
import { CompanyBusinessRelationships } from "./CompanySummarySteps/CompanyBusinessRelationships";
import { VisitDetailsEidValidation } from "./CompanySummarySteps/VisitDetailsEidValidation";
import { ComplianceConfirmation } from "./CompanySummarySteps/ComplianceConfirmation";
import { CompanyBankingRelationships } from "./CompanySummarySteps/CompanyBankingRelationships";
import { CompanyBranchesAndSubsidiaries } from "./CompanySummarySteps/CompanyBranchesAndSubsidiaries";
import { CompanyAnticipatedTransaction } from "./CompanySummarySteps/CompanyAnticipatedTransaction";
import { CompanyAccountAttributes } from "./CompanySummarySteps/CompanyAccountAttributes";
import { InwardCheques } from "./CompanySummarySteps/InwardCheques";
import { OutwardCheques } from "./CompanySummarySteps/OutwardCheques";
import { AdditionalSecurity } from "./CompanySummarySteps/AdditionalSecurity";
import { PosDetails } from "./CompanySummarySteps/PosDetails";
import { SignatoryBankingRelationships } from "../SignatorySummarySalesAssistCard/SignatorySummarySteps/SignatoryBankingRelationships";
import { SignatoryResidenceAddress } from "../SignatorySummarySalesAssistCard/SignatorySummarySteps/SignatoryRecidenceAddress";
import { GA_EVENTS } from "../../../../utils/ga";

export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;
export const STEP_6 = 6;
export const STEP_7 = 7;
export const STEP_8 = 8;
export const STEP_9 = 9;
export const STEP_10 = 10;
export const STEP_11 = 11;
export const STEP_12 = 12;

export const FINAL_QUESTIONS__SALES_ASSIST_COMPANY_ID = "finalQuestionsSalesAssistCompany";
export const FINAL_QUESTIONS__SALES_ASSIST_SIGNATORY_ID = "finalQuestionsSalesAssistSignatory_";

export const finalQuestionsSteps = [
  {
    step: STEP_1,
    title: "Visit details - EID Validation",
    component: VisitDetailsEidValidation,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_EID_VALIDATION_CONTINUE
  },
  {
    step: STEP_2,
    title: "Business relationships",
    component: CompanyBusinessRelationships,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_BUSINESS_RELATIONSHIPS_CONTINUE
  },
  {
    step: STEP_3,
    title: "Banking relationships",
    component: CompanyBankingRelationships,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_BANKING_RELATIONSHIPS_CONTINUE
  },
  {
    step: STEP_4,
    title: "Branches and subsidiaries",
    component: CompanyBranchesAndSubsidiaries,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_BRANCHES_CONTINUE
  },
  {
    step: STEP_5,
    title: "Anticipated Transactions",
    component: CompanyAnticipatedTransaction,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_ANTICIPATED_CONTINUE
  },
  {
    step: STEP_6,
    title: "Compliance Confirmation",
    component: ComplianceConfirmation,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_COMPLIANCE_CONFIRMATION_CONTINUE
  },
  {
    step: STEP_7,
    title: "Inward Cheques",
    component: InwardCheques,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_INWARD_CONTINUE
  },
  {
    step: STEP_8,
    title: "Outward Cheques",
    component: OutwardCheques,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_OUTWARD_CONTINUE
  },
  {
    step: STEP_9,
    title: "Additional Security",
    component: AdditionalSecurity,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_ADDITIONAL_SECURITY_CONTINUE
  },
  {
    step: STEP_10,
    title: "POS Details",
    component: PosDetails,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_POS_CONTINUE
  },
  {
    step: STEP_11,
    title: "Account Attributes",
    component: CompanyAccountAttributes,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_ACCOUNT_ATTRIBUTES_CONTINUE
  }
];

export const stakeholderFinalQuestionsSteps = [
  {
    step: STEP_1,
    title: "Banking relationships",
    component: SignatoryBankingRelationships,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_BANKING_RELATIONSHIPS_CONTINUE
  },
  {
    step: STEP_2,
    title: "Residence Address",
    component: SignatoryResidenceAddress,
    eventName: GA_EVENTS.SA_FINAL_QUESTION_RESIDENCE_ADDRESS_CONTINUE
  }
];
